export class LeiGlobalModel {
  constructor(
    public onboardCode : string = '',
    public submitter : SubmitterDetails = null,
    public legalEntityDetails : Array<LegalEntityDetail> = [],
    public verificationDetails : VerificationDetails = null,
  ) {  }
}



export class SubmitterDetails {
  constructor(
    public name : string = '',
    public email : string = '',
    public phone : string = ''
  ) {  }
}

export class VerificationDetails {
  constructor(
    public email : string = '',
    public code : string = '',
  ) {  }
}

export class LegalEntityDetails {

  constructor(
    public legalEntityDetails : Array<LegalEntityDetail> = []
  ) {  }
}

export class LegalEntityDetail {

  constructor(
    public isCardOpen: boolean = null,
    public leiCorrelationId:number = 0,
    public legalEntityId : string = '',
    public legalName: string = '',
    public mifidInScope: string = '',
    public domicile:string = '',
    public researchCost: string = '',
    public packagesDetails : Array<PackageDetails> = [],
    public paymentDetails : PaymentDetails = null,
    public invoiceDetails : InvoiceDetails = null,
    public contacts : Array<Contact> = [] //; todo:revert back when you use ngfor for contacts //Array<Contact> = []
  ) {  }
}

export class PackageDetails {

  constructor(
    public packageCorrelationId : number = 0,
    public service : string = '',
    public products : string[] = [],
    public exemption: string = ''
  ) {

  }
}

export class PaymentDetails {

  constructor(
    public taxNumber : string = '',
    public method: string = '',
    public rpaAdminName : string = '',
    public rpaAdminEmail : string = '',
    public rpaAdminPhone : string = '',
    public payViaRPA : boolean = null,
    public vatRegistered : boolean = null,
    public preferredCurrency : string = ''
  ) {

  }
}


export class InvoiceDetails {

  constructor(
    public name : string = '',
    public email: string = '',
    public phone: string = '',
    public address : InvoiceAddress = null
  ) {  }
}

export class InvoiceAddress {

  constructor(
    public line1 : string = '',
    public line2: string = '',
    public line3: string = '',
    public city : string = '',
    public postcode: string = '',
    public country : string = ''
  ) {  }
}


export class Contact {

  constructor(
    public contactCorrelationId : number = 0,
    public name : string = '',
    public email: string = '',
    public job: string = '',
    public location : string = '',
    public salesRepresentative : string = ''
  ) {  }
}

export const countries_old = [
  {"name": "Afghanistan", "display": "Afghanistan"},
  {"name": "Aland Islands", "display": "Åland Islands"},
  {"name": "Albania", "display": "Albania"},
  {"name": "Algeria", "display": "Algeria"},
  {"name": "American Samoa", "display": "American Samoa"},
  {"name": "Andorra", "display": "Andorra"},
  {"name": "Angola", "display": "Angola"},
  {"name": "Anguilla", "display": "Anguilla"},
  {"name": "Antarctica", "display": "Antarctica"},
  {"name": "Antigua and Barbuda", "display": "Antigua and Barbuda"},
  {"name": "Argentina", "display": "Argentina"},
  {"name": "Armenia", "display": "Armenia"},
  {"name": "Aruba", "display": "Aruba"},
  {"name": "Australia", "display": "Australia"},
  {"name": "Austria", "display": "Austria"},
  {"name": "Azerbaijan", "display": "Azerbaijan"},
  {"name": "Bahamas", "display": "Bahamas"},
  {"name": "Bahrain", "display": "Bahrain"},
  {"name": "Bangladesh", "display": "Bangladesh"},
  {"name": "Barbados", "display": "Barbados"},
  {"name": "Belarus", "display": "Belarus"},
  {"name": "Belgium", "display": "Belgium"},
  {"name": "Belize", "display": "Belize"},
  {"name": "Benin", "display": "Benin"},
  {"name": "Bermuda", "display": "Bermuda"},
  {"name": "Bhutan", "display": "Bhutan"},
  {"name": "Bolivia", "display": "Bolivia"},
  {"name": "Bosnia and Herzegovina", "display": "Bosnia and Herzegovina"},
  {"name": "Botswana", "display": "Botswana"},
  {"name": "Bouvet Island", "display": "Bouvet Island"},
  {"name": "Brazil", "display": "Brazil"},
  {"name": "British Indian Ocean Territory", "display": "British Indian Ocean Territory"},
  {"name": "Brunei Darussalam", "display": "Brunei Darussalam"},
  {"name": "Bulgaria", "display": "Bulgaria"},
  {"name": "Burkina Faso", "display": "Burkina Faso"},
  {"name": "Burundi", "display": "Burundi"},
  {"name": "Cambodia", "display": "Cambodia"},
  {"name": "Cameroon", "display": "Cameroon"},
  {"name": "Canada", "display": "Canada"},
  {"name": "Cape Verde", "display": "Cape Verde"},
  {"name": "Cayman Islands", "display": "Cayman Islands"},
  {"name": "Central African Republic", "display": "Central African Republic"},
  {"name": "Chad", "display": "Chad"},
  {"name": "Chile", "display": "Chile"},
  {"name": "China", "display": "China"},
  {"name": "Christmas Island", "display": "Christmas Island"},
  {"name": "Cocos (Keeling) Islands", "display": "Cocos (Keeling) Islands"},
  {"name": "Colombia", "display": "Colombia"},
  {"name": "Comoros", "display": "Comoros"},
  {"name": "Congo", "display": "Congo"},
  {"name": "Cook Islands", "display": "Cook Islands"},
  {"name": "Costa Rica", "display": "Costa Rica"},
  {"name": "Cote DIvoire", "display": "Cote D'Ivoire"},
  {"name": "Croatia", "display": "Croatia"},
  {"name": "Cuba", "display": "Cuba"},
  {"name": "Cyprus", "display": "Cyprus"},
  {"name": "Czech Republic", "display": "Czech Republic"},
  {"name": "Denmark", "display": "Denmark"},
  {"name": "Djibouti", "display": "Djibouti"},
  {"name": "Dominica", "display": "Dominica"},
  {"name": "Dominican Republic", "display": "Dominican Republic"},
  {"name": "Ecuador", "display": "Ecuador"},
  {"name": "Egypt", "display": "Egypt"},
  {"name": "El Salvador", "display": "El Salvador"},
  {"name": "Equatorial Guinea", "display": "Equatorial Guinea"},
  {"name": "Eritrea", "display": "Eritrea"},
  {"name": "Estonia", "display": "Estonia"},
  {"name": "Ethiopia", "display": "Ethiopia"},
  {"name": "Falkland Islands (Malvinas)", "display": "Falkland Islands (Malvinas)"},
  {"name": "Faroe Islands", "display": "Faroe Islands"},
  {"name": "Fiji", "display": "Fiji"},
  {"name": "Finland", "display": "Finland"},
  {"name": "France", "display": "France"},
  {"name": "French Guiana", "display": "French Guiana"},
  {"name": "French Polynesia", "display": "French Polynesia"},
  {"name": "French Southern Territories", "display": "French Southern Territories"},
  {"name": "Gabon", "display": "Gabon"},
  {"name": "Gambia", "display": "Gambia"},
  {"name": "Georgia", "display": "Georgia"},
  {"name": "Germany", "display": "Germany"},
  {"name": "Ghana", "display": "Ghana"},
  {"name": "Gibraltar", "display": "Gibraltar"},
  {"name": "Greece", "display": "Greece"},
  {"name": "Greenland", "display": "Greenland"},
  {"name": "Grenada", "display": "Grenada"},
  {"name": "Guadeloupe", "display": "Guadeloupe"},
  {"name": "Guam", "display": "Guam"},
  {"name": "Guatemala", "display": "Guatemala"},
  {"name": "Guernsey", "display": "Guernsey"},
  {"name": "Guinea", "display": "Guinea"},
  {"name": "Guinea-Bissau", "display": "Guinea-Bissau"},
  {"name": "Guyana", "display": "Guyana"},
  {"name": "Haiti", "display": "Haiti"},
  {"name": "Heard Island and Mcdonald Islands", "display": "Heard Island and Mcdonald Islands"},
  {"name": "Holy See (Vatican City State)", "display": "Holy See (Vatican City State)"},
  {"name": "Honduras", "display": "Honduras"},
  {"name": "Hong Kong", "display": "Hong Kong"},
  {"name": "Hungary", "display": "Hungary"},
  {"name": "Iceland", "display": "Iceland"},
  {"name": "India", "display": "India"},
  {"name": "Indonesia", "display": "Indonesia"},
  {"name": "Iran", "display": "Iran"},
  {"name": "Iraq", "display": "Iraq"},
  {"name": "Ireland", "display": "Ireland"},
  {"name": "Isle of Man", "display": "Isle of Man"},
  {"name": "Israel", "display": "Israel"},
  {"name": "Italy", "display": "Italy"},
  {"name": "Jamaica", "display": "Jamaica"},
  {"name": "Japan", "display": "Japan"},
  {"name": "Jersey", "display": "Jersey"},
  {"name": "Jordan", "display": "Jordan"},
  {"name": "Kazakhstan", "display": "Kazakhstan"},
  {"name": "Kenya", "display": "Kenya"},
  {"name": "Kiribati", "display": "Kiribati"},
  {"name": "S Korea", "display": "S Korea"},
  {"name": "Kuwait", "display": "Kuwait"},
  {"name": "Kyrgyzstan", "display": "Kyrgyzstan"},
  {"name": "Latvia", "display": "Latvia"},
  {"name": "Lebanon", "display": "Lebanon"},
  {"name": "Lesotho", "display": "Lesotho"},
  {"name": "Liberia", "display": "Liberia"},
  {"name": "Liechtenstein", "display": "Liechtenstein"},
  {"name": "Lithuania", "display": "Lithuania"},
  {"name": "Luxembourg", "display": "Luxembourg"},
  {"name": "Macao", "display": "Macao"},
  {"name": "Macedonia", "display": "Macedonia"},
  {"name": "Madagascar", "display": "Madagascar"},
  {"name": "Malawi", "display": "Malawi"},
  {"name": "Malaysia", "display": "Malaysia"},
  {"name": "Maldives", "display": "Maldives"},
  {"name": "Mali", "display": "Mali"},
  {"name": "Malta", "display": "Malta"},
  {"name": "Marshall Islands", "display": "Marshall Islands"},
  {"name": "Martinique", "display": "Martinique"},
  {"name": "Mauritania", "display": "Mauritania"},
  {"name": "Mauritius", "display": "Mauritius"},
  {"name": "Mayotte", "display": "Mayotte"},
  {"name": "Mexico", "display": "Mexico"},
  {"name": "Micronesia", "display": "Micronesia"},
  {"name": "Moldova", "display": "Moldova"},
  {"name": "Monaco", "display": "Monaco"},
  {"name": "Mongolia", "display": "Mongolia"},
  {"name": "Montserrat", "display": "Montserrat"},
  {"name": "Morocco", "display": "Morocco"},
  {"name": "Mozambique", "display": "Mozambique"},
  {"name": "Myanmar", "display": "Myanmar"},
  {"name": "Namibia", "display": "Namibia"},
  {"name": "Nauru", "display": "Nauru"},
  {"name": "Nepal", "display": "Nepal"},
  {"name": "New Zealand", "display": "New Zealand"},
  {"name": "Nicaragua", "display": "Nicaragua"},
  {"name": "Niger", "display": "Niger"},
  {"name": "Nigeria", "display": "Nigeria"},
  {"name": "Niue", "display": "Niue"},
  {"name": "Norfolk Island", "display": "Norfolk Island"},
  {"name": "Northern Mariana Islands", "display": "Northern Mariana Islands"},
  {"name": "Norway", "display": "Norway"},
  {"name": "Oman", "display": "Oman"},
  {"name": "Pakistan", "display": "Pakistan"},
  {"name": "Palau", "display": "Palau"},
  {"name": "Palestinian Territory, Occupied", "display": "Palestinian Territory, Occupied"},
  {"name": "Panama", "display": "Panama"},
  {"name": "Papua New Guinea", "display": "Papua New Guinea"},
  {"name": "Paraguay", "display": "Paraguay"},
  {"name": "Peru", "display": "Peru"},
  {"name": "Philippines", "display": "Philippines"},
  {"name": "Pitcairn", "display": "Pitcairn"},
  {"name": "Poland", "display": "Poland"},
  {"name": "Portugal", "display": "Portugal"},
  {"name": "Puerto Rico", "display": "Puerto Rico"},
  {"name": "Qatar", "display": "Qatar"},
  {"name": "Reunion", "display": "Reunion"},
  {"name": "Romania", "display": "Romania"},
  {"name": "Russian Federation", "display": "Russian Federation"},
  {"name": "RWANDA", "display": "RWANDA"},
  {"name": "Saint Helena", "display": "Saint Helena"},
  {"name": "Saint Kitts and Nevis", "display": "Saint Kitts and Nevis"},
  {"name": "Saint Lucia", "display": "Saint Lucia"},
  {"name": "Saint Pierre and Miquelon", "display": "Saint Pierre and Miquelon"},
  {"name": "Saint Vincent and the Grenadines", "display": "Saint Vincent and the Grenadines"},
  {"name": "Samoa", "display": "Samoa"},
  {"name": "San Marino", "display": "San Marino"},
  {"name": "Sao Tome and Principe", "display": "Sao Tome and Principe"},
  {"name": "Saudi Arabia", "display": "Saudi Arabia"},
  {"name": "Senegal", "display": "Senegal"},
  {"name": "Serbia and Montenegro", "display": "Serbia and Montenegro"},
  {"name": "Seychelles", "display": "Seychelles"},
  {"name": "Sierra Leone", "display": "Sierra Leone"},
  {"name": "Singapore", "display": "Singapore"},
  {"name": "Slovakia", "display": "Slovakia"},
  {"name": "Slovenia", "display": "Slovenia"},
  {"name": "Solomon Islands", "display": "Solomon Islands"},
  {"name": "Somalia", "display": "Somalia"},
  {"name": "South Africa", "display": "South Africa"},
  {"name": "South Georgia and the South Sandwich Islands", "display": "South Georgia and the South Sandwich Islands"},
  {"name": "Spain", "display": "Spain"},
  {"name": "Sri Lanka", "display": "Sri Lanka"},
  {"name": "Sudan", "display": "Sudan"},
  {"name": "Suriname", "display": "Suriname"},
  {"name": "Svalbard and Jan Mayen", "display": "Svalbard and Jan Mayen"},
  {"name": "Swaziland", "display": "Swaziland"},
  {"name": "Sweden", "display": "Sweden"},
  {"name": "Switzerland", "display": "Switzerland"},
  {"name": "Syrian Arab Republic", "display": "Syrian Arab Republic"},
  {"name": "Taiwan, Province of China", "display": "Taiwan, Province of China"},
  {"name": "Tajikistan", "display": "Tajikistan"},
  {"name": "Tanzania", "display": "Tanzania"},
  {"name": "Thailand", "display": "Thailand"},
  {"name": "Timor-Leste", "display": "Timor-Leste"},
  {"name": "Togo", "display": "Togo"},
  {"name": "Tokelau", "display": "Tokelau"},
  {"name": "Tonga", "display": "Tonga"},
  {"name": "Trinidad and Tobago", "display": "Trinidad and Tobago"},
  {"name": "Tunisia", "display": "Tunisia"},
  {"name": "Turkey", "display": "Turkey"},
  {"name": "Turkmenistan", "display": "Turkmenistan"},
  {"name": "Turks and Caicos Islands", "display": "Turks and Caicos Islands"},
  {"name": "Tuvalu", "display": "Tuvalu"},
  {"name": "Uganda", "display": "Uganda"},
  {"name": "Ukraine", "display": "Ukraine"},
  {"name": "United Arab Emirates", "display": "United Arab Emirates"},
  {"name": "United Kingdom", "display": "United Kingdom"},
  {"name": "United States", "display": "United States"},
  {"name": "United States Minor Outlying Islands", "display": "United States Minor Outlying Islands"},
  {"name": "Uruguay", "display": "Uruguay"},
  {"name": "Uzbekistan", "display": "Uzbekistan"},
  {"name": "Vanuatu", "display": "Vanuatu"},
  {"name": "Venezuela", "display": "Venezuela"},
  {"name": "Viet Nam", "display": "Viet Nam"},
  {"name": "Virgin Islands, British", "display": "Virgin Islands, British"},
  {"name": "Virgin Islands, U.S.", "display": "Virgin Islands, U.S."},
  {"name": "Wallis and Futuna", "display": "Wallis and Futuna"},
  {"name": "Western Sahara", "display": "Western Sahara"},
  {"name": "Yemen", "display": "Yemen"},
  {"name": "Zambia", "display": "Zambia"},
  {"name": "Zimbabwe", "display": "Zimbabwe"}
];

export const countries = [
  "Afghanistan",
  "Aland Islands",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antarctica",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Bouvet Island",
  "Brazil",
  "British Indian Ocean Territory",
  "Brunei Darussalam",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Cocos (Keeling) Islands",
  "Colombia",
  "Comoros",
  "Congo",,
  "Cook Islands",
  "Costa Rica",
  "Cote D'Ivoire",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Falkland Islands (Malvinas)",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "French Southern Territories",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Heard Island and Mcdonald Islands",
  "Holy See (Vatican City State)",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran, Islamic Republic Of",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea North",
  "Korea South",
  "Kuwait",
  "Kyrgyzstan",
  "Lao",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libyan Arab Jamahiriya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macao",
  "Macedonia",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "Netherlands Antilles",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestinian Territory, Occupied",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Pitcairn",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Reunion",
  "Romania",
  "Russian Federation",
  "RWANDA",
  "Saint Helena",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Pierre and Miquelon",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia and Montenegro",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Georgia and the South Sandwich Islands",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suridisplay",
  "Svalbard and Jan Mayen",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syrian Arab Republic",
  "Taiwan, Province of China",
  "Tajikistan",
  "Tanzania, United Republic of",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "United States Minor Outlying Islands",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Viet Nam",
  "Virgin Islands, British",
  "Virgin Islands, U.S.",
  "Wallis and Futuna",
  "Western Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe"
];
